import React, { useEffect, useState, useRef } from "react";
import Swal2 from "sweetalert2";
import withReactContent from "sweetalert2-react-content";
import "../styles/payments.css";
import Loading from "../helpers/loading_component.js";
import emailjs from "@emailjs/browser";
import LoadingPopup from "../helpers/loading_component.js";
import SelectSearch from "react-select-search";
import { secretKey } from "../.././data";
import Select from "react-select";

const MySwal = withReactContent(Swal2);

const AddCheckListLawsuitQst = (props) => {
  const [loading, setLoading] = useState(true);
  const [question, setQuestion] = useState(
    props.mode === "edit" ? props.qst.question : ""
  );
  const [type, setType] = useState(
    props.mode === "edit" ? props.qst.type : "text"
  );
  const [options, setOptions] = useState(
    props.mode === "edit" ? props.qst.options : ""
  );

  const getData = () => {
    setLoading(true);
    setLoading(false);
  };

  useEffect(() => {
    getData();
  }, []);

  const validateQuestion = (e) => {
    if (
      question.length > 0 &&
      type.length > 0 &&
      (type === "select" ? options.length > 0 : true)
    ) {
      return true;
    } else {
      return false;
    }
  };

  const addQuestion = async (e) => {
    setLoading(true);
    if (validateQuestion()) {
      var body = {
        question: question,
        type: type,
        options: options,
      };

      await fetch("https://apidevkppp.ftpeople.pl/addCheckOptionsLawsuit", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: secretKey,
        },
        body: JSON.stringify(body),
      })
        .then((response) => response.text())
        .then((data) => {
          MySwal.fire({
            icon: "success",
            title: "Dodano",
            text: "nowe pytanie",
          }).then(async (result) => {
            props.close();
          });
        })
        .catch((error) => {});
    }
  };

  const editQuestion = async (e) => {
    setLoading(true);
    if (validateQuestion()) {
      var body = {
        question: question,
        type: type,
        options: options,
        id: props.qst.id,
      };

      await fetch("https://apidevkppp.ftpeople.pl/editCheckOptionsLawsuit", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: secretKey,
        },
        body: JSON.stringify(body),
      })
        .then((response) => response.text())
        .then((data) => {
          MySwal.fire({
            icon: "success",
            title: "Edytowano",
            text: "pytanie",
          }).then(async (result) => {
            props.close();
          });
        })
        .catch((error) => {});
    }
  };

  return (
    <div style={{ width: "60vw" }} className="mainContainerAddClientContact">
      {loading ? (
        <LoadingPopup id={"popUpLoading"} />
      ) : (
        <>
          <div className="closeButtonAP">
            <button className="closeClientButton" onClick={props.close}>
              X
            </button>
          </div>

          <div className="inputBox">
            <div className="inputCol_1">
              <label>
                Pytanie <span className="requiredStar">*</span>
              </label>
              <input
                style={{ boxSizing: "border-box" }}
                type="text"
                value={question}
                onChange={(e) => {
                  setQuestion(e.target.value);
                }}
              />
            </div>
          </div>

          <div className="inputBox">
            <div className="inputCol_1">
              <label>
                Rodzaj odpowiedzi <span className="requiredStar">*</span>
              </label>
              <select
                style={{ boxSizing: "border-box" }}
                value={type}
                onChange={(e) => {
                  setType(e.target.value);
                }}
              >
                <option key="text" value="text">
                  Tekst
                </option>
                <option key="checkbox" value="checkbox">
                  Checkbox
                </option>
                <option key="select" value="select">
                  Lista
                </option>
              </select>
            </div>
          </div>

          {type === "select" ? (
            <div className="inputBox">
              <div className="inputCol_1">
                <label>
                  Warianty odpowiedzi (wprowadź po przecinku){" "}
                  <span className="requiredStar">*</span>
                </label>
                <textarea
                  style={{ boxSizing: "border-box" }}
                  className="textAreaNote"
                  value={options}
                  onChange={(e) => {
                    setOptions(e.target.value);
                  }}
                />
              </div>
            </div>
          ) : (
            ""
          )}

          <div className="saveBoxAP">
            <button
              className="paymentMenuButton"
              onClick={props.mode === "edit" ? editQuestion : addQuestion}
            >
              {props.mode === "edit" ? "edytuj" : "zapisz"}
            </button>
          </div>
        </>
      )}
    </div>
  );
};

export default AddCheckListLawsuitQst;
